import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxIconModule } from '../icon/icon.module';
import { PhxInputGroup } from './phx-input-group.component';
import { PhxSearchInput } from './phx-search-input.component';
import { PhxInputComponent } from './phx-input.component';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxPasswordInput } from './phx-password-input.component';

@NgModule({
  imports: [
    NgCommonModule,
    ReactiveFormsModule,
    FormsModule,
    PhxIconModule,
    PhxDropdownModule,
    A11yModule,
    PhxTranslationsRootModule,
    PhxButtonModule,
    PhxIconButtonModule
  ],
  declarations: [PhxInputComponent, PhxInputGroup, PhxSearchInput, PhxPasswordInput],
  exports: [PhxInputComponent, PhxInputGroup, PhxSearchInput, PhxPasswordInput],
})
export class PhxInputModule { }
